import template from './coworking-total-area.jade';
import validation from '../../../services/validation';

export default angular
  .module('cian.addForm.coworkingTotalArea', [])
  .directive('cianAfAboutObjectCoworkingTotalArea', () => ({
    scope: {},
    bindToController: {
      ad: '=',
      form: '=',
    },
    controller(deviceService) {
      'ngInject';

      this.isMobile = deviceService.isMobile;

      this.areaMax = 10000000;
      this.areaMin = 0;

      this.validation = validation(this.form, 'totalArea', {
        parse: 'Введите число',
        required: 'Укажите площадь здания',
        min: 'Площадь должна быть больше 0',
        max: 'Допустимо не более 7 символов',
      });
    },
    controllerAs: 'commercialTotalArea',
    template,
  })).name;
